<template>
    <!-- Pricebook / Approved Parts List: full-height drawer — header + search on top, the list scrolls, Done at the bottom -->
    <div class="modal-content nrgItemsModal">
        <div class="modal-body !p-[15px] font-roboto flex flex-col min-h-0">
            <!-- Figma UQ "Approved Parts List Popup": shared modal header band + red X -->
            <FxModalHeader :title="modalTitle" @close="closeClicked()" />
            <!-- search -->
            <div class="relative flex-shrink-0 mb-[12px]">
                <svg class="absolute left-[14px] top-1/2 -translate-y-1/2 pointer-events-none" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="11" cy="11" r="7" stroke="#999999" stroke-width="2" /><path d="m20 20-3.5-3.5" stroke="#999999" stroke-width="2" stroke-linecap="round" />
                </svg>
                <input v-model="search" type="text" placeholder="Search part name…" aria-label="Search parts"
                    class="w-full h-[40px] pl-[42px] pr-[40px] rounded-full border-1 border-[#E1E5EF] bg-[#fff] text-[14px] text-[#333333] placeholder:text-[#999999] outline-none focus:border-[#00B7C2]">
                <button v-if="search" type="button" aria-label="Clear search"
                    class="absolute right-[10px] top-1/2 -translate-y-1/2 w-[22px] h-[22px] flex items-center justify-center rounded-full border-0 bg-[#F1F1F1] hover:bg-[#E4E4E4] p-0"
                    @click="search = ''">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="#666666" stroke-width="3" stroke-linecap="round" /></svg>
                </button>
            </div>
            <!-- list: takes the rest of the height and scrolls -->
            <div class="flex-1 min-h-0 flex flex-col gap-[6px] overflow-x-hidden overflow-y-auto pr-[6px]">
                <div v-for="(item, index) in filteredList" :key="index"
                    class="px-3 py-[7px] rounded-[5px] border border-[#EFEFEF]">
                    <label class="relative flex items-center justify-between gap-2 w-full cursor-pointer ">
                        <input v-model="selectedItems" type="checkbox" class="peer hidden" :value="{
                            title: item.part_name,
                            part_price: item.cost_with_markup ?? 0,
                            service_part_id: item.part_id,
                            service: item.service,
                            is_max_markup_applicable: item.is_max_markup_applicable ?? 0,
                            max_allowed_price: item.max_allowed_price
                        }">
                        <span class="text-[14px] text-[#666666] peer-checked:text-[#7695FF]">{{ item.part_name
                            }}</span>
                        <span class="peer-checked:hidden">
                            <img src="../../assets/images/double-check-grey.png" alt="Unchecked Icon"
                                class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] object-contain">
                        </span>
                        <span class="hidden peer-checked:!block">
                            <img src="../../assets/images/double-check-lightblue.png" alt="Checked Icon"
                                class="min-w-[24px] min-h-[24px] max-w-[24px] max-h-[24px] object-contain">
                        </span>
                    </label>
                </div>
                <EmptyState v-if="((filteredList ?? []).length == 0)" />
            </div>
            <div class="flex-shrink-0 flex justify-center pt-[15px] border-t-1 border-[#EFEFEF] mt-[10px]">
                <button
                    class="px-[32px] py-[8px] rounded-[5px] text-[14px] font-roboto transition duration-300 border-[#00B7C2] border-1 mobile:bg-[#00B7C2] laptop:bg-[#fff] mobile:text-[#fff] laptop:text-[#00B7C2] laptop:hover:bg-[#00B7C2] laptop:hover:text-[#fff]"
                    @click="doneBtnClicked()">
                    Done
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyState from "@/components/partialComponent/EmptyState.vue";

import {
    mapActions,
    mapGetters
} from "vuex";
import { enableScroll } from "../../helpers/scrollHelper";
import FxModalHeader from "../nest_components/FxModalHeader.vue";

export default {
    components: { EmptyState,
        FxModalHeader,
    },
    props: ["list", "openModal"],

    data() {
        return {
            modal: null,
            search: '',
            selectedItems: [],
            partListArray: []
        }
    },
    computed: {
        ...mapGetters(["apiCallCallback", "partList", "partCategories", "quoteDetail"]),

        filteredList() {
            return this.partListArray.filter((item) => {
                return Object.keys(item)
                    .some(key => ('' + item[key]).toLowerCase().includes(this.search.toLowerCase()))
            })
        },

        isPartnerQuote() {
            return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
        },

        isShowApproved() {
            return this.quoteDetail?.partner_info?.show_approved_item_text == 1 || false
        },

        // same titles as before: partner quotes with approved items → "Approved Parts List", else "Pricebook"
        modalTitle() {
            return this.isPartnerQuote && Object.keys(this.quoteDetail || {}).length > 0 && this.isShowApproved
                ? "Approved Parts List" : "Pricebook"
        },

    },

    watch: {


        partList: function () {

        },

        openModal: function () {
            this.partListArray = [];
            let itemsids = [];
            this.list.forEach(item => {
                itemsids.push(item.service_part_id);
            });
            this.partListArray = this.partList.filter((e) => !itemsids.includes(e.part_id));
        },

    },

    mounted() {
        if (this.isPartnerQuote) {
            this.getPartCategoriesData()
            this.getPartList({
                url: "/partner/parts/list",
                params: {
                    uq_id: this.quoteDetail.id
                }
            });
        } else {
            this.getPartList({
                url: "/universal_quote/parts/list",
                params: {
                    manual_quote_id: this.quoteDetail.id
                }
            });
        }
    },

    methods: {

        ...mapActions(["getPartList", "getPartCategories"]),


        getPartCategoriesData() {
            this.getPartCategories({
                trade_id: this.quoteDetail.trade_id,
                uq_id: this.quoteDetail.id
            });
        },

        doneBtnClicked() {
            this.$emit("event", this.selectedItems)
            this.closeClicked()
        },

        closeClicked() {
            enableScroll()
            document.documentElement.style.overflow = '';
            this.search = '',
                this.selectedItems = []
        },
    }

}
</script>
